<template>
  <div id="app">
    
    <titleBar />
    <footBar />

    <view class="container">
    <router-view></router-view>
    </view>
    
  </div>
</template>

<script>
  import titleBar from './components/titleBar';
  import footBar from './components/footBar';
  export default {
    name: 'vue-electron-demo',
    components: {
      titleBar,
      footBar
    }
  }
</script>

<style>
html,
body,
div {
  margin: 0;
  padding: 0;
}

.container{
  width: 100%;
  position: absolute;
  margin-bottom:50px;
  overflow-y:auto;
  height: 100%;
  padding: 64px 0 40px;
}
</style>